import React from 'react';
import { Col, Container, Row } from 'reactstrap';

function Talleres(props){ 
    return (
        <>
            <section className="section section-lg pt-6 bg-secondary mt-5">
                <Container className="mb-6">
                    <Row className="row-grid align-items-center">
                        <Col className lg="12">
                        <div className="pl-4 align-component-enter">
                            <h4 className="display-3">Talleres y espacios de trabajo</h4>
                        </div>
                        </Col>
                    </Row>
                    <Row className="mt-6">
                        <ul>
                            <li>Hacia la vida Independiente: elección de talleres y actividades de interés</li>
                            <li>Taller de comunicación y radio.</li>
                            <li>Taller de Participación y Comunicación activa.</li>
                            <li>Taller de autodeterminación.</li>
                            <li>Taller de Estimulación Cognitiva.</li>
                            <li>Taller de Educación Física</li>
                            <li>Taller de literatura y actualidad</li>
                            <li>Taller estrategias de aprendizaje de la vida diaria</li>
                            <li>Taller de autocuidado y bienestar integral</li>
                            <li>Taller de estimulación multisensorial "Activando sentidos"</li>
                            <li>Tiempo libre y ocio</li>
                            <li>Taller habilidades académicas funcionales</li>
                            <li>Taller de computación</li>
                            <li>Taller de Danzas</li>
                            <li>Taller autosustentable</li>
                            <li>Taller jardinería y huerta</li>
                            <li>Taller carpintería</li>
                            <li>Taller de gastronomía</li>
                            <li>Taller de manualidades textiles</li>
                            <li>Taller de artesanías y manualidades</li>
                            <li>Ferias propias y comunitarias</li>
                            <li>Participación en torneos de Futbol y diferentes actividades deportivas</li>
                            <li>Festejos varios</li>
                            <li>Colonia de Verano en el Complejo de Puntalara</li>
                            <li>Salidas a la comunidad propuestas por los espacios y salidas recreativas</li>
                            <li>Trabajo conjunto con instituciones y actores comunitarios</li>
                        </ul>
                    </Row>
                </Container>
            </section>   
        </>   
    );


}


export default Talleres;